import request from "@/utils/request";
import axios from "axios";
const BASE_API = process.env.VUE_APP_BASE_API;

export function getCustomList(params) {
  return request({
    url: `${BASE_API}/oem/api/custom_list`,
    method: "get",
    params,
  });
}

export function getCopyCustom(params) {
  return request({
    url: `${BASE_API}/oem/api/copy_custom`,
    method: "get",
    params,
  });
}